<template>
    <Card>
        <div class="card-body">
            <FormGroup label="URL" class="mb-0">
                <InputGroup>
                    <Input v-model="link" :disabled="true"/>
                    <template #prepend>
                        <Button
                            @click="copyLink"
                            color="light"
                            class="mr-2"
                            style="float: right;"
                            :icon="true"
                        >
                            <i class="icon-copy"></i>
                            {{ translate('buttons.copy') }}
                        </Button>
                    </template>
                </InputGroup>
            </FormGroup>
            <Button
                @click="$refs.ExportProductsModal.show()"
                color="teal"
                class="mt-2"
            >
                {{ $t('buttons.start_export') }}
            </Button>
        </div>
        <Table :handle="tableHandle" :columns="table.columns" :url="table.url" v-model:orders="table.orders">
            <template #td-file="{row}">
                <AppNullableCell>
                    <template #default v-if="row.file">
                        <a :href="row.file.url">
                            <i class="icon-file-pdf mr-2"></i>
                            <span>{{ $t('labels.file') }}</span>
                        </a>
                    </template>
                </AppNullableCell>
            </template>
            <template #td-last_read_at="{row}">
                <AppNullableCell>
                    <template #default v-if="row.last_read_at">
                        {{ row.last_read_at }}
                    </template>
                </AppNullableCell>
            </template>
            <template #td-started_at="{row}">
                <AppNullableCell>
                    <template #default v-if="row.started_at">
                        {{ row.started_at }}
                    </template>
                </AppNullableCell>
            </template>
            <template #td-finished_at="{row}">
                <AppNullableCell>
                    <template #default v-if="row.finished_at">
                        {{ row.finished_at }}
                    </template>
                </AppNullableCell>
            </template>
            <template #td-exception_message="{row}">
                <u v-if="row.exception_message === null" class="text-muted">{{ $t('placeholders.missing') }}</u>
                <span v-else>{{ $t(showExceptionMessage(row.exception_message)) }}</span>
            </template>
        </Table>
    </Card>
    <ExportProductsModal ref="ExportProductsModal" :integration="integration" @export:started="tableHandle.fetchRows()" />
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue'
import FormGroup from '../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../components/new/form/Input.vue';
import Button from '../../../../components/new/button/AppButton.vue';
import InputGroup from '../../../../components/new/form/InputGroup.vue';
import { generateUrl } from '../../../../utils';
import { mapGetters } from "vuex";
import Table from "../../../../components/new/table/FetchTable.vue";
import { createTableHandle } from "../../../../components/new/table/tableHandle";
import AppNullableCell from "../../../components/tables/AppNullableCell.vue";
import ExportProductsModal from '../modals/ExportProductsModal.vue';

export default {
    name: "CopyLinkModal",
    components: {
        Card, FormGroup, Input, Button, InputGroup, Table, AppNullableCell, ExportProductsModal
    },
    props: ['integration'],
    data() {
        return {
            tableHandle: createTableHandle(),
            table: {
                url: `/integrations/${this.$route.params.integrationUuid}/exports`,
                columns: [
                    { key: "id", name: this.$t('table.titles.id'), width: "200px", type: "string", order: true },
                    { key: "file", name: this.$t('table.titles.file'), width: "200px", type: "string", order: false },
                    { key: "last_read_at", name: this.$t('table.titles.last_read_at'), width: "200px", type: "string", order: false },
                    { key: "created_at", name: this.$t('table.titles.created_at'), width: "200px", type: "string", order: true },
                    { key: "started_at", name: this.$t('table.titles.started_at'), width: "200px", type: "string", order: false },
                    { key: "finished_at", name: this.$t('table.titles.finished_at'), width: "200px", type: "string", order: false },
                    { key: "exception_message", name: this.$t('table.titles.error'), width: "200px", type: "string", order: false },
                ],
                orders: [
                    {
                        column: "created_at",
                        dir: "desc"
                    }
                ]
            },
        }
    },
    methods: {
        copyLink() {
            const textArea = document.createElement("textarea");
            textArea.value = this.link;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
        },
        showExceptionMessage(exceptionMessage) {
            if (exceptionMessage === 'Server error, please contact support.') {
                return 'alerts.server_error'
            }

            return exceptionMessage
        },
        onNotification(notification) {
            const exportEventTypes = [
                "App\\Modules\\Integration\\Notifications\\IntegrationExportProductsStartedNotification",
                "App\\Modules\\Integration\\Notifications\\IntegrationExportProductsFinishedNotification"
            ]

            if (exportEventTypes.includes(notification.type)) {
                this.tableHandle.fetchRows()
            }
        },
    },
    computed: {
        link() {
            return generateUrl(`integrations/${this.integration.uuid}/feed/file`)
        },
        ...mapGetters({
            project: "route/project",
            profile: "profile/profile"
        }),
    },
    mounted() {
        this.tableHandle.fetchRows()

        this.emitter.on('notification:received', this.onNotification)
    },
    beforeUnmount() {
        this.emitter.off('notification:received', this.onNotification)
    }
}
</script>
